import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 15.3vw;
    max-height: 60vh;
    padding-right: 2vw;
    top: 8.5vh;
    background-color: #fff;
    border: 1px solid #000;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1;
`

export const OptionDiv = styled.div`
    display: flex;
    width: 17.3vw;
    justify-content: center;
    align-items: center;
    min-height: 5vh;
    max-height: 5vh;
    cursor: pointer;

    :hover{
        background-color: #EBEBEB;
    }
`

export const OptionText = styled.p`
    font-size: 1vw;
    font-family: 'Inter', sans-serif;
`
